import { supabase } from '../supabase';

/**
 * Enhanced Utility for Google Analytics & Supabase Persistence
 */
export const trackEvent = async (action, category, label, value = null) => {
  // 1. Google Analytics Tracking
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
      timestamp: new Date().toISOString()
    });
  }

  // 2. Database Persistence for Admin Insights
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    await supabase.from('user_events_1740500000000').insert([{
      event_name: action,
      category: category,
      label: label,
      user_id: user?.id || null,
      metadata: {
        path: window.location.pathname,
        agent: navigator.userAgent.slice(0, 100),
        value: value
      }
    }]);
  } catch (err) {
    // Silent fail for analytics to prevent UI disruption
    console.debug('Analytics sync skipped');
  }
};

/**
 * Tracks button clicks with the button name as the primary action
 */
export const trackClick = (buttonName, context = 'General') => {
  trackEvent(buttonName, context, 'Button Interaction');
};

/**
 * Tracks specific user submissions
 */
export const trackReview = (placeName, rating) => {
  trackEvent('Submit Review', 'Reviews', placeName, rating);
};